<template>
  <Cell class="cell-tax">
    <div class="global-position global-position-wrap">
      <input
        ref="input"
        :value="name"
        :disabled="!editable"
        :class="{ 'global-position-input-purple': isPurple }"
        class="global-position-input"
        placeholder="Enter name"
        type="text"
        @keyup.enter="enter"
        @blur="(e) => $emit('change', { value: e.target.value, oldVal: name })"
      />
    </div>
  </Cell>
</template>
<script>
  import Cell from '@/components/common/Cell';

  export default {
    name: 'TaxInput',
    components: { Cell },
    props: {
      name: String,
      isPurple: Boolean,

      editable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        open: false,
        oldVal: this.name,
      };
    },
    methods: {
      enter() {
        this.$refs.input.blur();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .global-position {
    position: relative;
  }

  .global-position.global-position-data {
    margin-left: -8px;
  }
  .global-position-wrap {
    position: relative;
    z-index: auto;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }
</style>
